<template>
  <div class="auth-page" id="form-reset-password">
    <div class="auth-page__inner">
      <div class="auth-page__brand">
        <div class="auth-page__brand-bg"></div>
        <div class="auth-page__brand-pattern"></div>
        <div class="auth-page__brand-content">
          <h1 class="auth-page__brand-title">Bảo mật tài khoản</h1>
          <p class="auth-page__brand-desc">Đặt mật khẩu mới đủ mạnh: có chữ hoa, chữ thường, số và ký tự đặc biệt.</p>
          <ul class="auth-page__brand-features">
            <li>
              <span class="auth-page__brand-features-icon"><i class="fa fa-lock"></i></span>
              <span><strong>Mật khẩu mạnh</strong> Ít nhất 8 ký tự, có chữ hoa, chữ thường, số và ký tự đặc biệt (@$!%*?&).</span>
            </li>
            <li>
              <span class="auth-page__brand-features-icon"><i class="fa fa-repeat"></i></span>
              <span><strong>Không trùng mật khẩu cũ</strong> Mật khẩu mới phải khác mật khẩu hiện tại để đảm bảo an toàn.</span>
            </li>
            <li>
              <span class="auth-page__brand-features-icon"><i class="fa fa-sign-out"></i></span>
              <span><strong>Đăng xuất sau khi đổi</strong> Sau khi đổi mật khẩu thành công, bạn cần đăng nhập lại bằng mật khẩu mới.</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="auth-page__form-side">
        <div class="auth-page__form-side-pattern" aria-hidden="true"></div>
        <div class="auth-page__wrap">
          <CCard no-body class="auth-page__card">
            <CCardBody class="auth-page__card-body">
              <CForm id="form-reset" class="auth-page__form">
                <h2 class="auth-page__title form-fade-in-top">Đổi mật khẩu</h2>
                <p class="auth-page__subtitle">Mật khẩu mới không được trùng mật khẩu hiện tại</p>
                <div class="form-fade-in-bottom">
              <div class="mb-2">
                <BaseInput
                  :options="oldPasswordInput.options"
                  :data="oldPasswordInput.data"
                />
              </div>
              <div class="mb-2">
                <BaseInput
                  :options="newPassWordInput.options"
                  :data="newPassWordInput.data"
                />
              </div>
              <div class="mb-2">
                <BaseInput
                  :options="confirmPassWordInput.options"
                  :data="confirmPassWordInput.data"
                />
              </div>
              <div class="auth-page__btn-group auth-page__btn-group--row">
                <button type="button" class="auth-btn-secondary" @click="cancel()">
                  Hủy bỏ
                </button>
                <button type="button" class="auth-btn-primary btn-primary" @click="submit">
                  Xác nhận
                </button>
              </div>
                </div>
              </CForm>
            </CCardBody>
          </CCard>
        </div>
      </div>
    </div>
    <BaseLoading :loading="loading.value"></BaseLoading>
  </div>
</template>

<script>
import BaseLoading from "../base/BaseFormLoading";
import BaseInput from "../base/BaseInput";
import {authLogout, isAuthorized} from "@/security/index";
import {ACCESS_TOKEN_EXPIRED} from "@/constant";
import { RESET_PASSWORD_REQUIRED } from '../../constant';

export default {
  name: 'ResetPassword',
  components: {BaseLoading, BaseInput},
  notifications: {
    showSuccessMsg: {
      type: 'success',
      title: 'Success',
    },
    showErrorMsg: {
      type: 'error',
      title: 'Error',
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  mounted() {
    this.checkTimeExpToken();
  },
  data: function () {
    let that = this;
    return {
      loading: {value: false},
      oldPasswordInput: {
        options: {
          label: "Mật khẩu hiện tại <span class='required'>*</span>",
          placeholder: "Mật khẩu hiện tại",
          type: "password"
        },
        data: {
          name: "oldPassword",
          model: "",
          updateCallback: function () {
            that.submit();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.oldPasswordInput.data.model;
              let password_regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,128}$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Mật khẩu cũ không được để trống";
              } else if (password_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Mật khẩu cũ sai định dạng";
              } else if (password_regex.test(value) == true) {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      newPassWordInput: {
        options: {
          label: "Mật khẩu mới <span class='required'>*</span>",
          placeholder: "Mật khẩu mới",
          type: "password"
        },
        data: {
          name: "newPassword",
          model: "",
          updateCallback: function () {
            that.submit();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.newPassWordInput.data.model;
              let password_regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,128}$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Mật khẩu mới không được để trống";
              } else if (password_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Mật khẩu mới sai định dạng";
              } else if (value.localeCompare(that.oldPasswordInput.data.model) == 0) {
                this.isValid = false;
                this.errorMessage = "Mật khẩu mới không trùng mật khẩu hiện tại";
              } else if (password_regex.test(value) == true) {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
      confirmPassWordInput: {
        options: {
          label: "Xác nhận mật khẩu <span class='required'>*</span>",
          placeholder: "Xác nhận mật khẩu",
          type: "password"
        },
        data: {
          name: "newPasswordConfirm",
          model: "",
          updateCallback: function () {
            that.submit();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.confirmPassWordInput.data.model;
              let password_regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,128}$/;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Xác nhận mật khẩu không được để trống";
              } else if (password_regex.test(value) == false) {
                this.isValid = false;
                this.errorMessage = "Xác nhận mật khẩu sai định dạng";
              } else if (value.localeCompare(that.newPassWordInput.data.model) != 0) {
                this.isValid = false;
                this.errorMessage = "Xác nhận mật khẩu không trùng mật khẩu mới";
              } else if (password_regex.test(value) == true) {
                this.isValid = true;
                this.errorMessage = "";
              }
              return this.isValid;
            }
          }
        }
      },
    }
  },
  computed: {},
  methods: {
    checkTimeExpToken() {
      let timeExpired = localStorage.getItem(ACCESS_TOKEN_EXPIRED)
      if (timeExpired) {
        let expiredTime = new Date(timeExpired * 1)
        let time = new Date();
        if (time >= expiredTime) {
          authLogout();
        }
      }
    },
    submit: function () {
      let that = this;
      let isValid = true;
      isValid = that.oldPasswordInput.data.validator.valid() && isValid;
      isValid = that.newPassWordInput.data.validator.valid() && isValid;
      isValid = that.confirmPassWordInput.data.validator.valid() && isValid;
      if (!isValid) {
        return;
      }
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/users/changePassword",
        isJsonContentType: false,
        dataSubmit: function () {
          // return that.$data;
          return {
            oldPassword: btoa(that.oldPasswordInput.data.model),
            newPassword: btoa(that.newPassWordInput.data.model),
            newPasswordConfirm: btoa(that.confirmPassWordInput.data.model),
          };
        },
        successCallback: function (response) {
          let dataResponse = response.data;
          if (dataResponse.returnCode !== 1) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
            that.$helper.setupErrorModel(response.data.data, that.$data)
          } else {
            that.showSuccessMsg({message: 'Thay đổi mật khẩu thành công'})
            that.logout();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    logout: function () {
      let that = this;
      that.$helper.loadDataSource({
        loading: that.loading,
        url: "/users/logout",
        successCallback: function (response) {
          if (response.status === 200) {
            let dataResponse = response.data;
            if (dataResponse.returnCode !== 1) {
              that.showErrorMsg({message: that.$helper.getStringError(dataResponse.data)});
            } else {
              authLogout()
            }
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    cancel: function () {
      if(localStorage.getItem(RESET_PASSWORD_REQUIRED) === 'true') {
        authLogout();
      } else {
        this.$router.go(-1);
      }
    }
  }
}
</script>
<style scoped>
</style>
